export default __webpack_public_path__ + "static/media/screenshot2.8bee8d84.png";